import { render, staticRenderFns } from "./menuWeekly.vue?vue&type=template&id=7b13cf37&scoped=true&"
import script from "./menuWeekly.vue?vue&type=script&lang=js&"
export * from "./menuWeekly.vue?vue&type=script&lang=js&"
import style0 from "./menuWeekly.vue?vue&type=style&index=0&id=7b13cf37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13cf37",
  null
  
)

export default component.exports